import { useSpring, animated } from '@react-spring/web'
import * as React from 'react'

import { config, type IconProps } from '#app/components/icon'

const Shop: React.FC<IconProps> = (props) => {
	const { animate = false, className, width, height } = props

	const [style, api] = useSpring(() => ({
		from: {
			opacity: 1,
		},
		config: {
			duration: 800,
		},
	}))

	React.useEffect(() => {
		if (animate) {
			Promise.all(
				api.start({
					to: [{ opacity: 0 }, { opacity: 1 }],
				}),
			).catch(console.error)
		}
	}, [animate, api])

	return (
		<span>
			<svg
				id="Ebene_1"
				data-name="Ebene 1"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 425.2 425.2"
				className={className}
				width={width || config.width}
				height={height || config.height}
			>
				<path // Bottom
					d="m385.99,376.22h-164.96c-16.62,0-33.25,0-49.87,0-15.4,0-30.79,0-46.19,0H57.64c-4.43,0-8.89-.16-13.31,0-.19,0-.39,0-.58,0l3.75,3.75v-24.82l-3.75,3.75h328.35c4.43,0,8.89.16,13.31,0,.19,0,.39,0,.58,0l-3.75-3.75v24.82c0,4.83,7.5,4.83,7.5,0v-24.82c0-2.03-1.72-3.75-3.75-3.75h-164.96c-16.62,0-33.25,0-49.87,0-15.4,0-30.79,0-46.19,0H57.64c-4.43,0-8.88-.08-13.31,0-.19,0-.39,0-.58,0-2.03,0-3.75,1.72-3.75,3.75v24.82c0,2.03,1.72,3.75,3.75,3.75h164.96c16.62,0,33.25,0,49.87,0,15.4,0,30.79,0,46.19,0h67.33c4.43,0,8.88.08,13.31,0,.19,0,.39,0,.58,0,4.83,0,4.83-7.5,0-7.5Z"
				/>
				<g // house walls
				>
					<path // top
						d="m66.9,195.69v-3.75c0-2.03,1.72-3.75,3.75-3.75h.48c3.71-.06,7.42,0,11.13,0h274.44c2.03,0,3.75,1.73,3.75,3.75v.28c.03.93.05,1.87.06,2.8.01.22.01.45.01.67H66.9Z"
					/>
					<path // sides + bottom
						d="m356.29,221.61c1.47,0,2.88-.28,4.16-.81v134.34c0,1.13-.4,1.99-1.03,2.58-.02.03-.04.06-.07.07-.01.02-.04.05-.07.07-.59.62-1.45,1.03-2.58,1.03h-.48c-3.71.06-7.42,0-11.13,0H70.65c-2.03,0-3.75-1.72-3.75-3.75v-.27c-.2-6.58,0-13.2,0-19.79v-114.59c1.39.62,2.93.97,4.55.97h2.95v129.88c2.62,0,5.25.05,7.86.05h270.63c-.07-5.43.06-10.88.06-16.31v-113.47h3.34Z"
					/>
				</g>
				<path // top display
					d="m301.68,38.88H125.5c-8.81,0-15.99,7.17-15.99,15.99v56.19c0,8.82,7.18,15.99,15.99,15.99h176.18c8.82,0,15.99-7.17,15.99-15.99v-56.19c0-8.82-7.17-15.99-15.99-15.99Zm7.99,72.18c0,4.41-3.59,7.99-7.99,7.99H125.5c-4.4,0-7.99-3.58-7.99-7.99v-56.19c0-4.41,3.59-7.99,7.99-7.99h176.18c4.4,0,7.99,3.58,7.99,7.99v56.19Z"
				/>
				<path // roof
					d="m105.15,188.19v7.5h172.55v-7.5H105.15Zm276.56,1.86c-5.84-9.6-11.69-19.2-17.54-28.8-3.31-5.44-6.62-10.87-9.92-16.3-.62-1.01-1.19-2.05-1.84-3.03-.9-1.33-2.2-1.84-3.7-1.87-4.78-.12-9.58,0-14.37,0H80.04c-1.29,0-2.23.53-2.83,1.31-.15.16-.29.34-.41.54-3.4,5.43-6.81,10.86-10.21,16.29-5.4,8.61-10.8,17.22-16.2,25.84-1.26,2-2.52,4.01-3.78,6.02-1.53,2.43.46,5.64,3.24,5.64h315.28c.78,0,1.56,0,2.34.01,2.33.01,4.67.03,7,.01,1.15.01,2.3,0,3.45-.02h.55c2.81,0,4.73-3.2,3.24-5.64Zm-318.52-1.86c-2.17,0-4.34-.04-6.52-.06.05-.09.1-.17.16-.26,2.15-3.44,4.31-6.88,6.47-10.32,5.4-8.61,10.8-17.22,16.2-25.84.87-1.38,1.74-2.77,2.61-4.16h256.14c2.93,0,5.89.11,8.83.05,2.9,4.77,5.81,9.55,8.72,14.32,5.26,8.63,10.52,17.27,15.78,25.9.04.07.08.13.12.2.04.06.07.11.1.17H63.19Z"
				/>
				<rect // left display holder
					x="156.34"
					y="125.02"
					width="7"
					height="18.78"
				/>
				<rect // right display holder
					x="264.84"
					y="125.49"
					width="7"
					height="15.88"
				/>
				<path // doors both
					d="m282.05,257.77h-136.78c-9.82,0-17.8,7.98-17.8,17.8v83.07h172.38v-83.07c0-9.82-7.98-17.8-17.8-17.8Zm10.8,93.87h-158.38v-76.07c0-5.96,4.84-10.8,10.8-10.8h136.78c5.96,0,10.8,4.84,10.8,10.8v76.07Z"
				/>
				<animated.rect // doors middle
					style={style}
					x="210.16"
					y="261.27"
					width="7"
					height="91.1"
				/>
				<path // lamb 1
					d="m53.27,187.87v22.41c0,8.45,5.8,15.58,13.63,17.61,1.46.37,2.98.57,4.55.57h15.52c6.03,0,11.38-2.95,14.68-7.48,2.2-3,3.5-6.7,3.5-10.7v-22.41h-51.88Zm44.88,22.41c0,6.16-5.01,11.18-11.18,11.18h-15.52c-1.62,0-3.16-.35-4.55-.97-3.91-1.74-6.63-5.67-6.63-10.21v-15.41h37.88v15.41Z"
				/>
				<path // lamb 2
					d="m98.15,187.87v22.41c0,4,1.3,7.7,3.5,10.7,3.31,4.53,8.66,7.48,14.69,7.48h15.52c6.02,0,11.38-2.95,14.68-7.48,2.2-3,3.5-6.7,3.5-10.7v-22.41h-51.89Zm44.89,22.41c0,6.16-5.02,11.18-11.18,11.18h-15.52c-6.17,0-11.19-5.02-11.19-11.18v-15.41h37.89v15.41Z"
				/>
				<path // lamb 3
					d="m143.04,187.87v22.41c0,4,1.3,7.7,3.5,10.7,3.3,4.53,8.66,7.48,14.68,7.48h15.52c6.03,0,11.38-2.95,14.69-7.48,2.2-3,3.5-6.7,3.5-10.7v-22.41h-51.89Zm44.89,22.41c0,6.16-5.02,11.18-11.19,11.18h-15.52c-6.16,0-11.18-5.02-11.18-11.18v-15.41h37.89v15.41Z"
				/>
				<path // lamb 4
					d="m187.93,187.87v22.41c0,4,1.3,7.7,3.5,10.7,3.3,4.53,8.65,7.48,14.68,7.48h15.52c6,0,11.32-2.92,14.63-7.4,2.2-2.98,3.52-6.66,3.55-10.64v-22.55h-51.88Zm44.88,22.55c-.08,6.1-5.06,11.04-11.18,11.04h-15.52c-6.17,0-11.18-5.02-11.18-11.18v-15.41h37.88v15.55Z"
				/>
				<path // lamb 5
					d="m232.81,188.02v22.4c0,3.97,1.28,7.65,3.45,10.64,3.3,4.57,8.68,7.55,14.74,7.55h15.52c6.02,0,11.37-2.95,14.68-7.48,2.2-3.01,3.5-6.71,3.5-10.71v-22.4h-51.89Zm44.89,22.4c0,6.17-5.02,11.19-11.18,11.19h-15.52c-6.17,0-11.19-5.02-11.19-11.19v-15.4h37.89v15.4Z"
				/>
				<path // lamb 6
					d="m277.7,188.02v22.4c0,4,1.3,7.7,3.5,10.71,3.31,4.53,8.66,7.48,14.68,7.48h15.52c6.03,0,11.38-2.95,14.69-7.48,2.2-3.01,3.5-6.71,3.5-10.71v-22.4h-51.89Zm44.89,22.4c0,6.17-5.02,11.19-11.19,11.19h-15.52c-6.16,0-11.18-5.02-11.18-11.19v-15.4h37.89v15.4Z"
				/>
				<path // lamb 7
					d="m322.59,188.02v22.4c0,4,1.3,7.7,3.5,10.71,3.3,4.53,8.65,7.48,14.68,7.48h15.52c1.43,0,2.82-.17,4.16-.48,8.03-1.89,14.02-9.11,14.02-17.71v-22.4h-51.88Zm44.88,22.4c0,4.7-2.91,8.73-7.02,10.38-1.28.53-2.69.81-4.16.81h-15.52c-6.17,0-11.18-5.02-11.18-11.19v-15.4h37.88v15.4Z"
				/>
				<animated.circle // left opener
					style={style}
					cx="198.9"
					cy="313.58"
					r="5.37"
				/>
				<animated.circle // left opener
					style={style}
					cx="198.9"
					cy="313.58"
					r="5.37"
				/>
				<animated.circle // right opener
					style={style}
					cx="228.09"
					cy="313.58"
					r="5.37"
				/>
			</svg>
		</span>
	)
}

export { Shop }
